import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import React, { useEffect } from "react";
import { useAPIDeleteKartuStokMinyak } from "../api/api-delete-kartu-stok-minyak";
import { ProgressSpinner } from "primereact/progressspinner";

const KartuStokMinyakDelete = (props) => {
  const { visible, onHide, editorData, onConfirmed } = props;

  const { loading, setData, handleOnDelete } = useAPIDeleteKartuStokMinyak({
    onConfirmed,
  });

  // use effect section

  useEffect(() => {
    if (visible) {
      setData(editorData);
    }
  }, [visible]);

  // handle ui event section

  // genereate editor element section

  const dialogFooter = (
    <React.Fragment>
      <Button label="Batal" text onClick={props.onHide} />
      <Button
        label="Lanjut Hapus"
        icon="pi pi-check"
        severity="danger"
        onClick={(e) => {
          handleOnDelete();
        }}
      />
    </React.Fragment>
  );

  return (
    <Dialog
      visible={visible}
      style={{ width: "22rem" }}
      breakpoints={{ "960px": "75vw", "641px": "90vw" }}
      header={"Konfirmasi"}
      modal
      className={`p-fluid`}
      footer={dialogFooter}
      onHide={onHide}
      contentClassName="py-4 !pb-6"
      pt={{ footer: { className: "py-4" }, header: { className: "py-4" } }}
    >
      <div className="col-start-center relative h-100 gap-3">
        <div className="row-start-center w-full gap-3 pb-2">
          <i className="pi pi-exclamation-triangle text-red-500 text-4xl" />
          <span className="font-semibold text-slate-500">
            Menghapus data, lanjutkan?
          </span>
        </div>
        {loading && (
          <div
            className={`col-center-center w-100  gap-2 absolute z-100 h-100 bg-black/20 rounded `}
          >
            <ProgressSpinner />
          </div>
        )}
      </div>
    </Dialog>
  );
};

export default KartuStokMinyakDelete;
